'use strict';

var React = require('react');
var index = require('../../node_modules/google-map-react/lib/index.js');
var Marker = require('./Marker.js');
var Polygon = require('./Polygon.js');
var withGoogleMapsAPI = require('../../utils/withGoogleMapsAPI.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var DEFAULT_ZOOM = 9;

function Map(_ref) {
  var latitude = _ref.latitude,
      longitude = _ref.longitude,
      polygon = _ref.polygon,
      radius = _ref.radius,
      zoom = _ref.zoom,
      isBeingEdited = _ref.isBeingEdited,
      showMarker = _ref.showMarker,
      children = _ref.children,
      onPolygonEdit = _ref.onPolygonEdit,
      fitPolygonInMap = _ref.fitPolygonInMap,
      onMapLoaded = _ref.onMapLoaded;
  React.useEffect(function () {
    try {
      showMarker && Marker.resetMarker(latitude, longitude);
    } catch (error) {}
  }, [latitude, longitude]);
  var lat = latitude || 0;
  var lng = longitude || 0;
  return React__default["default"].createElement("div", {
    style: {
      height: '100%',
      width: '100%'
    }
  }, React__default["default"].createElement(index, {
    googleMapLoader: function googleMapLoader() {
      return Promise.resolve(window.google.maps);
    },
    bootstrapURLKeys: {
      key: process.env.GOOGLE_MAPS_API_KEY
    },
    center: [lat, lng],
    zoom: zoom,
    yesIWantToUseGoogleMapApiInternals: true,
    onGoogleApiLoaded: function onGoogleApiLoaded(_ref2) {
      var map = _ref2.map,
          maps = _ref2.maps;
      {
        radius > 0.0 && Polygon.buildPolygon(map, maps, lat, lng, polygon, radius, isBeingEdited, onPolygonEdit, fitPolygonInMap);
      }
      showMarker && Marker.buildMarker(map, maps, lat, lng);
      map.panTo(new window.google.maps.LatLng(lat, lng));

      if (onMapLoaded) {
        onMapLoaded(map, maps);
      }
    }
  }, children));
}

Map.defaultProps = {
  polygon: [],
  radius: 0.0,
  zoom: DEFAULT_ZOOM,
  isBeingEdited: false,
  fitPolygonInMap: true,
  showMarker: false,
  onMapLoaded: undefined
};
var MapWithGoogleApi = withGoogleMapsAPI.withGoogleMapsAPI()(Map);

module.exports = MapWithGoogleApi;
